/**
 * Fields in connection to partnership request state
 * @enum {string}
 */
export const fields = {
  FUNDING_ACCOUNT: 'partnershipRequestStateFundingAccount',
};
